import ELK from "elkjs/lib/elk.bundled";
import ElkOptions from "../constants/ElkOptions";

const getNodesMetaData = (item: $TSFixMe) => {
  const commonMetaData = {
    id: item.id.toString(),
    label: item.display_name,
    type: item.type,
    disabled: false,
  };
  switch (item.type) {
    case "Asset":
      return {
        ...commonMetaData,
        href: `/assets/${item.id}`,
        icon: "icon3-eh-products",
      };
    case "Instrumentation":
      return {
        ...commonMetaData,
        href: `/instrumentations/${item.id}`,
        icon: "lcm-iot-icon-instrumentation",
      };
    case "Node":
      return {
        ...commonMetaData,
        href: `/nodes/${item.id}`,
        icon: "icon3-eh-folder",
      };
    default:
      return {
        ...commonMetaData,
        icon: "icon3-eh-folder",
        disabled: true,
      };
  }
};

export const transformPathsToTopology = (paths: $TSFixMe, id: $TSFixMe) => {
  const nodes = new Map();
  const edges: $TSFixMe = [];
  const objectId = id?.toString() ?? undefined;

  nodes.set(0, {
    id: "0",
    position: { x: 0, y: 0 },
    type: "input",
    data: {
      id: "all_objects",
      label: "All Objects",
      href: "/nodes",
      isFirst: true,
    },
  });

  paths.forEach((path: $TSFixMe, index: $TSFixMe) => {
    path.items.reduce((previousNodeId: $TSFixMe, item: $TSFixMe) => {
      const itemId = item.id.toString();
      const isLast = objectId === itemId;

      if (!nodes.has(itemId)) {
        const metaData = getNodesMetaData(item);

        nodes.set(itemId, {
          id: itemId,
          position: { x: 0, y: 0 },
          ...(isLast && { type: "output" }),
          data: {
            ...metaData,
            isLast,
          },
        });
      }

      edges.push({
        id: `e${previousNodeId}-${itemId}-${index}`,
        source: previousNodeId,
        target: itemId,
      });

      return itemId;
    }, "0");
  });

  return {
    initialNodes: Array.from(nodes.values()),
    initialEdges: edges,
  };
};

export const layoutTopology = async (nodes: $TSFixMe, edges: $TSFixMe) => {
  const elk = new ELK();
  const topology = {
    id: "root",
    layoutOptions: ElkOptions,
    children: nodes.map((node: $TSFixMe) => ({
      ...node,
      targetPosition: "left",
      sourcePosition: "right",
      type: "custom",
      width: 200,
      height: 150,
    })),
    edges,
  };

  const layoutedTopology = await elk.layout(topology);
  return {
    nodes: layoutedTopology.children?.map((node) => ({
      ...node,
      position: { x: node.x, y: node.y },
    })),
    edges: layoutedTopology.edges,
  };
};
